const DEFAULT_WILDCARD = '#'

export default function useMask(wildcard = DEFAULT_WILDCARD) {
  const applySingleMask = (value: string, mask: string): string => {
    if (!mask.length) {
      return value
    }

    const alphanumericValue = value.replace(/\W/g, '')
    let valueIndex = 0
    let maskedValue = ''

    for (let i = 0; i < mask.length; i++) {
      if (valueIndex >= alphanumericValue.length) {
        break
      }

      if (mask[i] === wildcard) {
        maskedValue += alphanumericValue[valueIndex++]
      } else {
        maskedValue += mask[i]
      }
    }

    return maskedValue
  }

  const applyMask = (value: string, masks: string | string[]): string => {
    const alphanumericValue = value.replace(/\W/g, '')

    if (Array.isArray(masks)) {
      let maskedValue = ''
      for (const mask of masks) {
        maskedValue = applySingleMask(value, mask)
        const processedMask = mask.replace(
          new RegExp(`[^${wildcard}]`, 'g'),
          ''
        )
        if (alphanumericValue.length <= processedMask.length) {
          if (
            maskedValue.replace(/\W/g, '').length === alphanumericValue.length
          ) {
            return maskedValue
          }
        }
      }
      return maskedValue
    }
    return applySingleMask(value, masks)
  }

  return { applyMask }
}
